import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'placeSearchNot'
})
export class PlaceSearchNotPipe implements PipeTransform {

  transform(arr: any, root: any): any {
    if ( root == '' || root == null || root == undefined || root == 'Search By Branch' || root == 'All' || root == 'Search By Store' || arr == [] || arr == undefined || arr == null) {
      return arr;
    } else{
      return arr.filter((arr: any) =>{
        return !arr.place.toString().includes(root.toString())
      })
    }
  }

}
